export default "__VITE_ASSET__Dqfx4oRP__"